import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useLolStatsAggregateQuery } from '@/services/qriotsApi';
import type { Platform } from '@/types/qriots';
import { classifyQriotsError } from '@/services/qriotsErrors';
import { Loader } from '@/components/common/Loader';
import { StatsCard } from '@/components/riot/StatsCard';
import { QriotsErrorState } from '@/components/riot/QriotsErrorState';

export function RiotLolStats() {
  const { t } = useTranslation('riot');
  const { puuid = '' } = useParams<{ puuid: string }>();
  const [search] = useSearchParams();
  const region = (search.get('region') ?? 'EUW1') as Platform;

  const result = useLolStatsAggregateQuery(
    { puuid, region, window: 20 },
    { skip: !puuid },
  );

  if (result.isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (result.error) {
    const { kind, retryAfterSec } = classifyQriotsError(result.error);
    return (
      <QriotsErrorState
        kind={kind}
        retryAfterSec={retryAfterSec}
        onRetry={result.refetch}
      />
    );
  }

  if (!result.data) return null;

  return (
    <div className="flex flex-col gap-3 pb-6 pt-4">
      <div className="mx-4">
        <h2 className="text-base font-bold text-fg">{t('stats.title')}</h2>
      </div>
      <StatsCard data={result.data} />
    </div>
  );
}
